import { useGetTriages } from "@partners/ui/api";

import type { ProfileMenuProps } from "@/components/ProfileMenu";

import { ProfileMenu } from "@/components/ProfileMenu";

export const ProfileMenuWithTriage = ({
  onboardingState,
  isMAMMaster,
  isIdentityOnlyUser,
  userName,
}: Omit<ProfileMenuProps, "hasTriagesCompleted" | "isTriageEnabled">) => {
  const { data: triageData } = useGetTriages({ status: "complete" });
  const hasTriagesCompleted = (triageData && triageData.length > 0) ?? false;

  return (
    <ProfileMenu
      onboardingState={onboardingState}
      isMAMMaster={isMAMMaster}
      isTriageEnabled={true}
      hasTriagesCompleted={hasTriagesCompleted}
      isIdentityOnlyUser={isIdentityOnlyUser}
      userName={userName}
    />
  );
};
